module.exports = __webpack_public_path__ + "static/sport/banner1.85b9cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner1.png
// module id = gb9W
// module chunks = 0